"use strict";

angular.module("diceApp").factory("SecuredOperation", function (DiceResource) {
  return DiceResource("/secured-operations");
});
